<template>
    <div class="relative flex items-center justify-between">
        <h3 class="text-md font-bold uppercase">{{ $t('profile_edit.announcer') }}</h3>
        <Toggle v-model="announcerEnabled" class="cursor-pointer" testid="announcer-toggle" />
        <Transition name="fade" mode="out-in">
            <div
                class="absolute top-0 right-0 flex h-full w-full items-center justify-center bg-zinc-800/90 "
                v-if="isSaving"
            >
                <svg
                    class="h-5 w-5 animate-spin text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                >
                    <circle
                        class="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        stroke-width="4"
                    ></circle>
                    <path
                        class="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                </svg>
            </div>
        </Transition>
    </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useAuthStore } from '@/stores/auth.js'
import { apiService } from '@/services/api.js'
import Toggle from '@/components/ui/Form/Toggle.vue'

export default {
    name: 'AnnouncerToggle',
    components: { Toggle },
    data() {
        return {
            optimisticValue: null,
            isSaving: false,
        }
    },
    computed: {
        ...mapStores(useAuthStore),

        announcerEnabled: {
            get() {
                if (this.optimisticValue !== null) return this.optimisticValue
                return this.authStore.profile?.announcer_enabled ?? true
            },
            set(value) {
                this.save(value)
            },
        },
    },
    methods: {
        async save(value) {
            if (this.isSaving) return

            const previous = this.announcerEnabled
            this.optimisticValue = value
            this.isSaving = true

            try {
                await apiService.put('/api/v1/user/announcer-enabled', {
                    announcer_enabled: value,
                })
                await this.authStore.verifyToken()
                this.optimisticValue = null
            } catch (error) {
                console.error('Failed to update announcer setting:', error)
                this.optimisticValue = previous
                this.$toast(this.$t('general.error_title'), 3000, this.$t('general.error_retry'))
            } finally {
                this.isSaving = false
            }
        },
    },
}
</script>

<style>
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.1s;
    }
    .fade-enter-from,
    .fade-leave-to {
        opacity: 0;
    }
</style>